import React, { useState } from 'react';
import { Navigate } from 'react-router';

import { isUserLoggedIn, LoginScreen, StandardLoginScreenContents } from '@paragon/login-tools';

import { useAppSelector } from './hooks';

export function ServicesSignUp() {
  const loggedInUser = useAppSelector((state) => isUserLoggedIn(state));
  const [accountCreatedInCurrentFlow, setAccountCreatedInCurrentFlow] = useState(false);

  if (loggedInUser && !accountCreatedInCurrentFlow) return <Navigate to="/" replace />;
  return (
    <LoginScreen hideTermsAndPrivacy>
      <StandardLoginScreenContents signUp onAccountCreated={() => setAccountCreatedInCurrentFlow(true)} />
    </LoginScreen>
  );
}
